import React from "react";
import { Row, Col, FormGroup, Input, Label } from "reactstrap";

import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import SystemLabel from "../../../../../../system/SystemLabel/SystemLabel";

import JirangoSwitch from "../../../../../../components/JirangoSwitch/JirangoSwitch";
import SaveIcon from "@material-ui/icons/Save";
import AddIcon from "@material-ui/icons/Add";
import DeleteIcon from "@material-ui/icons/Delete";
import Select from "react-select";
import "./MeetingsLayoutSettings.css";
// import { digitalMeetingModules } from "../../../../../../digitalmeeting/modules";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Slide from "@material-ui/core/Slide";
import PopEditorClassic from "../../../../../../components/TinyMCE/PopEditorClassic";
import UrlMultiInput from "../../../../../../components/UrlMultiInput/UrlMultiInput";
import {
  Dialog,
  Tooltip,
  DialogContent,
  DialogTitle,
  Table,
  Paper,
  DialogContentText,
  DialogActions,
} from "@material-ui/core";
import { CodeMirror } from "../../../../../../plugins/CodeMirror";
import SettingsIcon from "@material-ui/icons/Settings";
import CodeIcon from "@material-ui/icons/Code";

import KeyboardBackspaceIcon from "@material-ui/icons/KeyboardBackspace";
import KeyboardIcon from "@material-ui/icons/Keyboard";
import PublishIcon from "@material-ui/icons/Publish";
import ImportExportIcon from "@material-ui/icons/ImportExport";
import ImportModules from "./ImportModules/ImportModules";

const value2 = [
  "ZoomFrame",
  "Exhibitors",
  "TimeoutContent",
  "BreakoutRandomizer",
  "Iframe",
];
const value = [
  "CompanyLogo",
  "Html",
  "Carousel",
  "Iframe",
  "Video",
  "ZoomFrame",
  "Image",
  "Exhibitors",
  "JitsiFrame",
  "BreakoutRandomizer",
  "TimeoutContent",
];
const value3 = ["BreakoutRandomizer"];

const customStyles = {
  control: (provided, state) => ({
    ...provided,

    backgroundColor: "#3d3d3d",
    color: "#eee",
    border: "0px",
    maxWidth: "100%",
  }),
  container: (provided, state) => ({
    ...provided,

    width: "100%",
  }),
  noOptionsMessage: (provided, state) => ({
    ...provided,
    color: "green",
    maxWidth: "100%",
  }),
  input: (provided, state) => ({
    ...provided,
    color: "#eee",
    maxWidth: "100%",
  }),
  singleValue: (provided, state) => ({
    ...provided,
    color: "#eee",
  }),
  menu: (provided, state) => ({
    ...provided,
    backgroundColor: "#3d3d3d",
    maxWidth: "100%",
    zIndex: 100,
  }),
  separatorIndicator: (provided, state) => ({
    ...provided,
    backgroundColor: "transparent",
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? "#20a8d8" : "#3d3d3d",
    color: "#eee",
    ["&:hover"]: {
      backgroundColor: "#5a5959ba",
    },
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "#eee",
  }),
};
export default class MeetingLayoutSettings extends React.Component {
  state = {
    loading: false,
    hasChanged: false,
    expanded: false,
    anchorEl: null,
    selList: [],
    editId: null,
    deleteId: null,
    open: false,
    editorType: "Text",
    selectedLayoutPreset: null,
    showAddPresetDialog: false,
    newPresetName: "",
    openImport: false,
  };

  componentDidMount() {
    this.generateModuleList();
  }
  componentDidUpdate(prevProps) {
    if (
      this.props.modules !== undefined &&
      prevProps.modules !== this.props.modules
    ) {
      this.generateModuleList();
    }
  }
  toggleModal = () => {
    this.setState({ open: !this.state.open });
  };
  handleChange = (value, path, index) => {
    const newModules = Array.from(this.props.modules);
    newModules[index][path] = value;
    this.props.updateModulesList(newModules);
    this.setState({
      hasChanged: true,
    });
  };
  handleImage = (url, index) => {
    const newModules = Array.from(this.props.modules);
    newModules[index].value = url;
    this.props.updateModulesList(newModules);
    this.setState({
      hasChanged: true,
    });
  };
  updateModules = () => {
    this.props.updateMeetingLayout();
    this.setState({
      hasChanged: false,
      loading: false,
    });
  };
  setComponent = (value) => {
    if (!value) return;
    this.setState({ createComponent: value });
  };
  selectLayoutPreset = (value) => {
    if (!value) return;
    this.setState({ selectedLayoutPreset: value, hasChanged: true });
    let p = this.props.meetingLayoutPresets.find((e) => e.name === value);
    if (p) {
      this.props.updateModulesList(p.content);
      this.props.selectPreset(p.interactionPresetId);
    }
  };
  deleteModule = (id) => {
    if (this.state.deleteId) {
      this.props.deleteModule(this.state.deleteId);
      this.setState({ open: false, deleteId: null });
    }
  };
  createModule = () => {
    const { createComponent } = this.state;
    if (!createComponent) return;
    this.props.addModule(createComponent);
  };
  createLayoutPreset = () => {
    this.props.saveMeetingLayoutPreset(this.state.newPresetName);
    this.selectLayoutPreset(this.state.newPresetName);
    this.setNewPresetName("");
    this.setState({ showAddPresetDialog: false });
  };
  saveMeetingLayoutPreset = () => {
    this.props.saveMeetingLayoutPreset(this.state.selectedLayoutPreset);
  };
  generateModuleList = () => {
    const comps = []//digitalMeetingModules;
    const { modules } = this.props;
    const selItems = [];
    comps.map((c) => {
      if (c.limit > 0 && !modules.find((m) => m.name === c.name)) {
        selItems.push({ label: c.name, value: c.name });
      } else if (c.limit === 0) {
        selItems.push({ label: c.name, value: c.name });
      }
    });
    this.setState({ selList: selItems });
  };
  setNewPresetName = (value) => {
    this.setState({ newPresetName: value });
  };
  headerRow = () => {
    return (
      <thead>
        <tr>
          <th
            style={{
              width: "10%",
              maxWidth: "10%",
              padding: 0,
              textAlign: "left",
            }}
          >
            <Typography
              component="h6"
              style={{
                fontSize: "12px",
                color: "#ffffff99",
                lineHeight: "2em",
              }}
            >
              <SystemLabel name="Component" />
            </Typography>
          </th>
          <th
            style={{
              width: "15%",
              maxWidth: "15%",
              padding: 0,
              textAlign: "left",
            }}
          >
            <Typography
              component="h6"
              style={{
                fontSize: "12px",
                color: "#ffffff99",
                lineHeight: "2em",
              }}
            >
              <SystemLabel name="DisplayName" />
            </Typography>
          </th>
          <th
            style={{
              width: "5%",
              maxWidth: "5%",
              padding: 0,
              textAlign: "left",
            }}
          >
            <Typography
              component="h6"
              style={{
                fontSize: "12px",
                color: "#ffffff99",
                lineHeight: "2em",
              }}
            >
              <SystemLabel name="Height" />
            </Typography>
          </th>
          <th
            style={{
              width: "5%",
              maxWidth: "5%",
              padding: 0,
              textAlign: "left",
            }}
          >
            <Typography
              component="h6"
              style={{
                fontSize: "12px",
                color: "#ffffff99",
                lineHeight: "2em",
              }}
            >
              <SystemLabel name="Width" />
            </Typography>
          </th>
          <th
            style={{
              width: "5%",
              maxWidth: "5%",
              padding: 0,
              textAlign: "left",
            }}
          >
            <Typography
              component="h6"
              style={{
                fontSize: "12px",
                color: "#ffffff99",
                lineHeight: "2em",
              }}
            >
              <SystemLabel name="X" />
            </Typography>
          </th>
          <th
            style={{
              width: "5%",
              maxWidth: "5%",
              padding: 0,
              textAlign: "left",
            }}
          >
            <Typography
              component="h6"
              style={{
                fontSize: "12px",
                color: "#ffffff99",
                lineHeight: "2em",
              }}
            >
              <SystemLabel name="Y" />
            </Typography>
          </th>
          <th
            style={{
              width: "5%",
              maxWidth: "5%",
              padding: 0,
              textAlign: "left",
            }}
          >
            <Typography
              component="h6"
              style={{
                fontSize: "12px",
                color: "#ffffff99",
                lineHeight: "2em",
              }}
            >
              <SystemLabel name="Z" />
            </Typography>
          </th>
          <th
            style={{
              width: "5%",
              maxWidth: "5%",
              padding: 0,
              textAlign: "center",
            }}
          >
            <Typography
              component="h6"
              style={{
                fontSize: "12px",
                color: "#ffffff99",
                lineHeight: "2em",
              }}
            >
              <SystemLabel name="Settings" />
            </Typography>
          </th>
          <th
            style={{
              width: "7.5%",
              maxWidth: "7.5%",
              padding: 0,
              textAlign: "center",
            }}
          >
            <Typography
              component="h6"
              style={{
                fontSize: "12px",
                color: "#ffffff99",
                lineHeight: "2em",
              }}
            >
              <SystemLabel name="Visble" />
            </Typography>
          </th>

          <th
            style={{
              width: "5%",
              maxWidth: "5%",
              padding: 0,
              textAlign: "center",
            }}
          >
            <Typography
              component="h6"
              style={{
                fontSize: "12px",
                color: "#ffffff99",
                lineHeight: "2em",
              }}
            >
              <SystemLabel name="Delete" />
            </Typography>
          </th>
        </tr>
      </thead>
    );
  };
  handleExpandClick = () => {
    this.setState({
      expanded: !this.state.expanded,
    });
    this.props.onExpand(!this.state.expanded);
  };
  getBreakoutName = (val) => {
    if (val && this.props.breakouts && this.props.breakouts.length > 0) {
      let br = this.props.breakouts.find((b) => b.eventId == val);
      return br ? br.name : "";
    } else return "";
  };
  render() {
    const { loading, hasChanged, expanded, anchorEl } = this.state;
    const { modules, meetingLayoutPresets } = this.props;
    const open = Boolean(anchorEl);
    const id = open ? "simple-popover" : undefined;
    const selectStyles = {
      container: (styles) => ({
        ...styles,
        minWidth: "calc(100% - 96px)",
        width: "100%",
        margin: "10px",
      }),
    };
    const layoutPresetOptions = meetingLayoutPresets
      ? meetingLayoutPresets.map((e) => {
          return { label: e.name, value: e.name };
        })
      : [];
    return (
      <div
        className="dark-card"
        style={{ position: "relative", paddingTop: 30, height: "100%" }}
      >
        <Row style={{ margin: 0 }}>
          <Col lg={8} sm={8} md={8} style={{ display: "flex" }}>
            <FormGroup style={{ width: "50%", padding: "0px 10px" }}>
              <Typography
                component="label"
                style={{
                  fontSize: "12px",
                  color: "#ffffff99",
                  marginLeft: 10,
                  lineHeight: "2em",
                  width: "100%",
                }}
              >
                <SystemLabel name="Presets" />
              </Typography>
              <div
                style={{
                  display: "inline-flex",
                  /*  marginRight: '170px' */ width: "100%",
                }}
              >
                <Select
                  className="jirango-select"
                  classNamePrefix="jirango-select"
                  options={layoutPresetOptions.sort(
                    (a, b) => a.sortOrder - b.sortOrder
                  )}
                  styles={customStyles}
                  value={
                    this.state.selectedLayoutPreset
                      ? {
                          label: this.state.selectedLayoutPreset,
                          value: this.state.selectedLayoutPreset,
                        }
                      : null
                  }
                  onChange={(selectedOption) =>
                    this.selectLayoutPreset(selectedOption.value)
                  }
                />
                <Tooltip title={<SystemLabel name="AddPreset" />}>
                  <IconButton
                    className="icon-button-dark-s"
                    onClick={() => this.setState({ showAddPresetDialog: true })}
                  >
                    <AddIcon />
                  </IconButton>
                </Tooltip>
                {/*                     <Tooltip title={<SystemLabel name="SavePreset" />}> */}
                <IconButton
                  className="icon-button-dark-s"
                  disabled={this.state.selectedLayoutPreset ? false : true}
                  onClick={this.saveMeetingLayoutPreset}
                >
                  <SaveIcon />
                </IconButton>
                {/*    </Tooltip> */}
              </div>
            </FormGroup>
            <FormGroup style={{ width: "50%", padding: "0px 10px" }}>
              <Typography
                component="label"
                style={{
                  fontSize: "12px",
                  color: "#ffffff99",
                  marginLeft: 10,
                  width: "100%",
                }}
              >
                <SystemLabel name="Modules" />
              </Typography>
              <div style={{ display: "inline-flex", width: "100%" }}>
                <Select
                  className="jirango-select"
                  classNamePrefix="jirango-select"
                  options={this.state.selList}
                  styles={customStyles}
                  value={
                    this.state.createComponent
                      ? {
                          label: this.state.createComponent,
                          value: this.state.createComponent,
                        }
                      : null
                  }
                  onChange={(selectedOption) =>
                    this.setComponent(selectedOption.value)
                  }
                />
                {/*          <Tooltip title={<SystemLabel name="AddModule" />} > */}
                <IconButton
                  className="icon-button-dark-s"
                  disabled={!this.state.createComponent}
                  onClick={() => this.createModule()}
                >
                  <AddIcon />
                </IconButton>
                {/*   </Tooltip> */}
                <Tooltip title={<SystemLabel name="PublishChanges" />}>
                  <span>
                    <IconButton
                      className="icon-button-dark-s"
                      disabled={!hasChanged}
                      style={
                        hasChanged
                          ? { background: "#3a3b3c", color: "#fff !important" }
                          : {}
                      }
                      onClick={this.updateModules}
                    >
                      {/*      {hasChanged ? <div className="info-pop">
                                        <Alert style={{ padding: 0 }} severity="info">   <SystemLabel name="PublishToArena" /></Alert>
                                    </div> : null} */}
                      <PublishIcon />
                    </IconButton>
                  </span>
                </Tooltip>
                <Tooltip title={<SystemLabel name="ImportModules" />}>
                  <IconButton
                    className="icon-button-dark-s"
                    onClick={() => this.setState({ openImport: true })}
                  >
                    <ImportExportIcon />
                  </IconButton>
                </Tooltip>
              </div>
            </FormGroup>
          </Col>
          <Col lg={4} sm={6} md={6}></Col>
        </Row>
        <hr style={{ background: "#3a3b3c7e" }} />
        <Row
          className="dark-list"
          style={{
            margin: "0px 0px 0px 24px",
            maxHeight: "calc(100vh - 234px)",
            overflowY: "auto",
          }}
        >
          <Table>
            {this.headerRow()}
            <tbody>
              {Array.isArray(modules) && modules.length > 0
                ? modules.map((m, i) => {
                    return (
                      <tr key={i}>
                        <td
                          className="dark-input-v"
                          style={{ width: "10%", maxWidth: "10%", padding: 0 }}
                        >
                          <FormGroup>
                            <Typography component="h4">
                              <SystemLabel name={m.name} />
                            </Typography>
                          </FormGroup>
                        </td>
                        <td
                          className="dark-input-v"
                          style={{ width: "15%", maxWidth: "15%", padding: 0 }}
                        >
                          <Input
                            onChange={(e) =>
                              this.handleChange(
                                e.target.value,
                                "displayName",
                                i
                              )
                            }
                            type="text"
                            value={m.displayName || ""}
                          />
                        </td>
                        <td
                          className="dark-input-v"
                          style={{ width: "5%", maxWidth: "5%", padding: 0 }}
                        >
                          <Input
                            onChange={(e) =>
                              this.handleChange(e.target.value, "height", i)
                            }
                            min={1}
                            max={100}
                            type="number"
                            value={m.height || ""}
                          />
                        </td>
                        <td
                          className="dark-input-v"
                          style={{ width: "5%", maxWidth: "5%", padding: 0 }}
                        >
                          <Input
                            onChange={(e) =>
                              this.handleChange(e.target.value, "width", i)
                            }
                            min={1}
                            max={100}
                            type="number"
                            value={m.width || ""}
                          />
                        </td>
                        <td
                          className="dark-input-v"
                          style={{ width: "5%", maxWidth: "5%", padding: 0 }}
                        >
                          <Input
                            onChange={(e) =>
                              this.handleChange(e.target.value, "x", i)
                            }
                            type="number"
                            value={m.x || ""}
                          />
                        </td>
                        <td
                          className="dark-input-v"
                          style={{ width: "5%", maxWidth: "5%", padding: 0 }}
                        >
                          <Input
                            onChange={(e) =>
                              this.handleChange(e.target.value, "y", i)
                            }
                            type="number"
                            value={m.y || ""}
                          />
                        </td>
                        <td
                          className="dark-input-v"
                          style={{ width: "5%", maxWidth: "5%", padding: 0 }}
                        >
                          <Input
                            onChange={(e) =>
                              this.handleChange(e.target.value, "z", i)
                            }
                            type="number"
                            value={m.z || ""}
                          />
                        </td>
                        <td
                          className="dark-input-v"
                          style={{
                            width: "5%",
                            maxWidth: "5%",
                            padding: 0,
                            textAlign: "center",
                          }}
                        >
                          {(value.includes(m.name) ||
                            value2.includes(m.name)) &&
                          m.name !== "Html" ? (
                            <SettingsPopper>
                              <React.Fragment>
                                {m.name == "Image" ? (
                                  <FormGroup>
                                    {m.value ? (
                                      <div
                                        style={{
                                          maxWidth: "100%",
                                          position: "relative",
                                          background: "#000000cf",
                                          btextAlign: "center",
                                          height: 230,
                                          marginBottom: 30,
                                        }}
                                      >
                                        {/*   <div style={{ width: '100%', height: '100%', background: '#000000cf' }}></div> */}
                                        <img
                                          className="centered-text"
                                          src={m.value}
                                          style={{
                                            maxWidth: "200",
                                            height: "auto",
                                            maxHeight: "200px",
                                          }}
                                        />
                                      </div>
                                    ) : null}
                                    <Typography component="h4">
                                      <SystemLabel name={m.name + "Value"} />
                                    </Typography>

                                    <UrlMultiInput
                                      onChange={(url) =>
                                        this.handleImage(url, i)
                                      }
                                      setImage={(url) =>
                                        this.handleImage(url, i)
                                      }
                                      margin={false}
                                      noInfoText={true}
                                      dark={true}
                                      colStyle={{ padding: 0, margin: 0 }}
                                      rowStyle={{ margin: "0px" }}
                                      url={m.value}
                                    />
                                  </FormGroup>
                                ) : m.name == "BreakoutRandomizer" ? (
                                  <FormGroup>
                                    <Typography component="h4">
                                      <SystemLabel name={m.name + "Value"} />
                                    </Typography>
                                    <Select
                                      className="jirango-select"
                                      classNamePrefix="jirango-select"
                                      options={this.props.breakouts.map((b) => {
                                        return {
                                          label: b.name,
                                          value: b.eventId,
                                        };
                                      })}
                                      styles={customStyles}
                                      value={
                                        m.value && this.props.breakouts
                                          ? {
                                              label: this.getBreakoutName(
                                                m.value
                                              ),
                                              value: m.value,
                                            }
                                          : null
                                      }
                                      onChange={(selectedOption) =>
                                        this.handleChange(
                                          selectedOption.value,
                                          "value",
                                          i
                                        )
                                      }
                                    />
                                  </FormGroup>
                                ) : value.includes(m.name) ? (
                                  <FormGroup>
                                    <Typography component="h4">
                                      <SystemLabel name={m.name + "Value"} />
                                    </Typography>
                                    <Input
                                      onChange={(e) =>
                                        this.handleChange(
                                          e.target.value,
                                          "value",
                                          i
                                        )
                                      }
                                      type={
                                        m.name == "TimeoutContent"
                                          ? "datetime-local"
                                          : "text"
                                      }
                                      value={
                                        m.value
                                          ? m.name == "timeoutContent"
                                            ? new Date(m.value)
                                                .toLocaleString()
                                                .replace(" ", "T")
                                            : m.value
                                          : ""
                                      }
                                    />
                                  </FormGroup>
                                ) : null}
                                {/*   {m.name == 'TimeoutContent' && value2.includes(m.name) ?
                                                    <div>
                                                        <Tooltip title={<SystemLabel name="OpenTextEditor" />}>
                                                            <IconButton className="icon-button-dark-s" onClick={() => this.setState({ editId: i, editorType: 'Text' })} >
                                                                <KeyboardIcon />
                                                            </IconButton>
                                                        </Tooltip>
                                                        <Tooltip title={<SystemLabel name="OpenHtmlEditor" />}>
                                                            <IconButton className="icon-button-dark-s" onClick={() => this.setState({ editId: i, editorType: 'Code' })} >
                                                                <CodeIcon />
                                                            </IconButton>
                                                        </Tooltip>
                                                    </div>
                                                    : null} */}
                                {m.name !== "Html" &&
                                value2.includes(m.name) ? (
                                  <Tooltip title={"Info2" + m.name + "Module"}>
                                    <FormGroup>
                                      <Typography component="h4">
                                        <SystemLabel name={m.name + "Value2"} />
                                      </Typography>
                                      <Input
                                        onChange={(e) =>
                                          this.handleChange(
                                            e.target.value,
                                            "value2",
                                            i
                                          )
                                        }
                                        type={
                                          m.name == "BreakoutRandomizer"
                                            ? "number"
                                            : "text"
                                        }
                                        value={m.value2 || ""}
                                      />
                                    </FormGroup>
                                  </Tooltip>
                                ) : null}
                                {m.name !== "Html" &&
                                value3.includes(m.name) ? (
                                  <Tooltip title={"Info2" + m.name + "Module"}>
                                    <FormGroup>
                                      <Typography component="h4">
                                        <SystemLabel name={m.name + "Value3"} />
                                      </Typography>
                                      <Input
                                        onChange={(e) =>
                                          this.handleChange(
                                            e.target.value,
                                            "value3",
                                            i
                                          )
                                        }
                                        type={
                                          m.name == "BreakoutRandomizer"
                                            ? "number"
                                            : "text"
                                        }
                                        value={m.value3 || ""}
                                      />
                                    </FormGroup>
                                  </Tooltip>
                                ) : null}
                                {m.name === "ZoomFrame" ? (
                                  <FormGroup>
                                    <Typography component="h4">
                                      <SystemLabel name={"StartZoomMeeting"} />
                                    </Typography>
                                    <JirangoSwitch
                                      onChange={(e) =>
                                        this.handleChange(
                                          !m.active,
                                          "active",
                                          i
                                        )
                                      }
                                      isChecked={m.active === true}
                                    />
                                  </FormGroup>
                                ) : null}
                              </React.Fragment>
                            </SettingsPopper>
                          ) : m.name == "Html" ? (
                            <div>
                              <Tooltip
                                title={<SystemLabel name="OpenTextEditor" />}
                              >
                                <IconButton
                                  className="icon-button-dark-s"
                                  onClick={() =>
                                    this.setState({
                                      editId: i,
                                      editorType: "Text",
                                    })
                                  }
                                >
                                  <KeyboardIcon />
                                </IconButton>
                              </Tooltip>
                              <Tooltip
                                title={<SystemLabel name="OpenHtmlEditor" />}
                              >
                                <IconButton
                                  className="icon-button-dark-s"
                                  onClick={() =>
                                    this.setState({
                                      editId: i,
                                      editorType: "Code",
                                    })
                                  }
                                >
                                  <CodeIcon />
                                </IconButton>
                              </Tooltip>
                            </div>
                          ) : null}
                        </td>

                        <td
                          className="dark-input-v"
                          style={{
                            width: "7.5%",
                            maxWidth: "7.5%",
                            padding: 0,
                            textAlign: "center",
                          }}
                        >
                          <JirangoSwitch
                            onChange={(e) =>
                              this.handleChange(!m.visible, "visible", i)
                            }
                            isChecked={m.visible === true}
                          />
                        </td>
                        <td
                          className="dark-input-v"
                          style={{
                            width: "5%",
                            maxWidth: "5%",
                            padding: 0,
                            textAlign: "center",
                          }}
                        >
                          <IconButton
                            className="icon-button-dark-s"
                            onClick={() =>
                              this.setState({
                                deleteId: m.digitalMeetingItemId,
                                open: true,
                              })
                            }
                          >
                            <DeleteIcon />
                          </IconButton>
                        </td>
                      </tr>
                    );
                  })
                : null}
            </tbody>
          </Table>
        </Row>

        {/* <List dense={true} style={{ maxHeight: '500px', overflowY: 'auto', zIndex: 0 }} >

                </List>
 */}
{/* 
        <ConfirmModal
          onAction={() => this.deleteModule()}
          onCancel={() => this.toggleModal(!this.state.open)}
          header={"AreYouSure"}
          open={this.state.open}
          text={"DoWantToDeleteModule"}
        /> */}

        {this.state.editId != null ? (
          <FullScreenDialog
            open={this.state.editId !== null}
            onClose={() => this.setState({ editId: null })}
            value={this.props.modules[this.state.editId].value}
            name={this.props.modules[this.state.editId].displayName}
            index={this.state.editId}
            editorType={this.state.editorType}
            onChange={this.handleChange}
          />
        ) : null}
        {this.state.openImport ? (
          <ImportModules
            toggleDialog={() =>
              this.setState({ openImport: !this.state.openImport })
            }
            isOpen={true}
            {...this.props}
          />
        ) : null}
        <Dialog
          open={this.state.showAddPresetDialog}
          onClose={() => null}
          TransitionComponent={Transition}
        >
          <DialogTitle>
            <SystemLabel name="CreatePreset" />
          </DialogTitle>
          <DialogContent>
            <Col>
              <FormGroup style={{ textAlign: "center" }}>
                <Label>
                  {" "}
                  <SystemLabel name="NamePreset" />
                </Label>
                <Input
                  onChange={(e) => this.setNewPresetName(e.target.value)}
                  type="text"
                  value={this.state.newPresetName}
                />
              </FormGroup>
            </Col>
            <Col>
              <Button onClick={this.createLayoutPreset}>Ok</Button>
              <Button
                onClick={() =>
                  this.setState({
                    showAddPresetDialog: false,
                    newPresetName: "",
                  })
                }
              >
                Avbryt
              </Button>
            </Col>
          </DialogContent>
        </Dialog>
      </div>
    );
  }
}

const useStyles = makeStyles((theme) => ({
  appBar: {
    position: "relative",
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  paper: {
    background: "#303030",
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
function FullScreenDialog(props) {
  const classes = useStyles();
  const handleClose = () => {
    props.onClose();
  };
  const onEdit = (value) => {
    props.onChange(value, "value", props.index);
  };
  /*    return (
           <PopEditorClassic
               value={props.value}
               editMode={true}
               classic={false}
               onChange={onEdit}
               slimFormat={true}
               path={'text'}
               style={undefined}
           />
       ) */
  return (
    <div>
      <div
        style={{
          width: "calc(100%)",
          height: "100vh",
          /* margin: '5%' */ position: "fixed",
          top: 0,
          left: 0,
          zIndex: 4000,
        }}
      >
        <AppBar className={classes.appBar}>
          <Toolbar>
            <IconButton
              edge="start"
              onClick={handleClose}
              style={{ color: "#fff" }}
              aria-label="close"
            >
              <KeyboardBackspaceIcon />
            </IconButton>
            {/*   <IconButton edge="start" onClick={handleClose} style={{ color: '#fff' }} aria-label="close">
                            <SaveIcon />
                        </IconButton> */}

            <Typography variant="h6" className={classes.title}>
              {props.editorType == "Text" ? (
                <SystemLabel name="TextEditor" />
              ) : (
                <SystemLabel name="HtmlEditor" />
              )}
            </Typography>
          </Toolbar>
        </AppBar>
        {props.editorType == "Text" ? (
          <PopEditorClassic
            value={props.value}
            editMode={true}
            classic={true}
            onChange={onEdit}
            slimFormat={true}
            path={"text"}
            style={undefined}
          />
        ) : (
          <CodeMirror value={props.value} onChange={onEdit} />
        )}
      </div>
    </div>
  );
}

/* const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
}); */

export function SettingsPopper(props) {
  const [open, setOpen] = React.useState(false);
  const classes = useStyles();

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <IconButton className="icon-button-dark-s" onClick={handleClickOpen}>
        <SettingsIcon />
      </IconButton>
      <Dialog
        className="no-bg"
        style={{ zIndex: 560, minWidth: 500, background: "#303030" }}
        open={open}
        TransitionComponent={Transition}
        keepMounted
        classes={{ paper: classes.paper }}
        onClose={() => null}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle className="secondary-text" id="alert-dialog-slide-title">
          <SystemLabel name="ModuleSettings" />
        </DialogTitle>
        <DialogContent style={{ minWidth: 500 }}>
          <DialogContentText
            component="div"
            className="dark-input-v "
            id="alert-dialog-slide-description"
          >
            {props.children}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} className="primary-text">
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
